import {dispatchSnackbar} from "../../../components/SnackBar/snackbar-bus"
import {parseClipboardCells, removeTableHeader} from "src/v2/utils/table-clipboard"

export const pasteTableFromClipboard = async (payload, callbackFunction, {validateHeader = false} = {}) => {
    try {
        const text = await navigator.clipboard.readText()
        if (!text?.trim()) return

        const keys = payload.map((field) => field.key)
        const cells = parseClipboardCells(text)
        const rows = validateHeader
            ? removeTableHeader(cells, keys, payload.map(field => field.label)).filter(row => row.some(value => value.trim()))
            : cells.filter(row => row.some(value => value.trim())).slice(1)
        const data = rows.map(row => {
            const obj = {}

            row.forEach((value, index) => {
                const key = keys[index]
                if (key) {
                    obj[key] = value.trim()
                }
            })

            return obj
        })
        if (callbackFunction !== null) {
            callbackFunction(data)
        }
    } catch (error) {
        dispatchSnackbar(error.message || "Erro ao ler a área de transferência.", "error")
    }
}

const CSV_SEPARATOR = ";"
export const escapeCsvValue = (value) => {
    if (value == null) return ""
    const stringValue = String(value)

    if (
        stringValue.includes(CSV_SEPARATOR) ||
        stringValue.includes('"') ||
        stringValue.includes("\n")
    ) {
        return `"${stringValue.replace(/"/g, '""')}"`
    }

    return stringValue
}

export const copyTable = async (tableData, fields) => {
    if (!tableData.length) return

    const headers = fields.map((field) => field.key)
    const csv = [
        headers.join(CSV_SEPARATOR),
        ...tableData.map((row) =>
            headers.map((header) => escapeCsvValue(row[header])).join(CSV_SEPARATOR)
        ),
    ].join("\n")

    try {
        await navigator.clipboard.writeText(csv)
        dispatchSnackbar("Dados copiados para a área de transferência", "success")
    } catch (error) {
        dispatchSnackbar(`Erro ao copiar a tabela: ${error}`, "error")
    }
}
